export const getPositionCount = (requests, positionId) => {
    return requests.filter((request) => request.columns.positionId === positionId).length;
};
